import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { IAutomateDiscountPayload } from 'app/typings/automateDiscount';
import { apiMutation } from 'app/utils/request/api';

import { getInventoryPath } from './hotels/extranet/useInventory';
import { extranetPackagePath } from './packages/usePackageExtranet';

export const path = '/extranet/:hotelId/automate-openings' as const;

export function useAutomateDiscountSave(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: IAutomateDiscountPayload) =>
      apiMutation(
        'POST',
        {
          path,
          params: { hotelId: hotelId.toString() },
        },
        payload
      ) as Promise<IAutomateDiscountPayload>,
    onSuccess: () => {
      queryClient.invalidateQueries([getInventoryPath]);
      queryClient.invalidateQueries([extranetPackagePath, { hotelId }]);

      message.success('Automated discount updated');
    },
    onError: () => {
      message.error('Error saving automated discount');
    },
  });
}

export function useAutomateDiscountDelete(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
    mutationFn: async (hotelId: number) =>
      apiMutation('DELETE', {
        path,
        params: { hotelId: hotelId.toString() },
      }) as Promise<[]>,
    onSuccess: (_) => {
      queryClient.invalidateQueries([extranetPackagePath, { hotelId }]);

      queryClient.invalidateQueries([getInventoryPath]);
      message.success('Automated discount disabled');
    },
    onError: (err) => {
      message.error('Error deleting automated discount');
    },
  });
}
